module.exports = __webpack_public_path__ + "img/1b44c8d.png";